import { useState } from "react";

export default function FloatingContactButtons() {
  const [hoveredCall, setHoveredCall] = useState(false);
  const [hoveredText, setHoveredText] = useState(false);
  const phoneNumber = "6789365391";

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">

      {/* Call Us button */}
      <a
        href={`tel:${phoneNumber}`}
        className="flex items-center gap-2 cursor-pointer no-underline"
        onMouseEnter={() => setHoveredCall(true)}
        onMouseLeave={() => setHoveredCall(false)}
        aria-label="Call us at 678-936-5391"
      >
        <span
          className={`
            bg-gray-900 text-white text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap
            transition-all duration-300 ease-in-out
            ${hoveredCall ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4 pointer-events-none"}
          `}
        >
          Call Us: 678-936-5391
        </span>
        <div
          className="w-14 h-14 rounded-full bg-red-600 flex items-center justify-center hover:bg-red-700 active:scale-95 transition-all duration-200"
          style={{ boxShadow: "0 4px 20px rgba(220,38,38,0.45)" }}
        >
          <i className="ri-phone-fill text-white text-2xl"></i>
        </div>
      </a>

      {/* Text Us button */}
      <a
        href={`sms:${phoneNumber}`}
        className="flex items-center gap-2 cursor-pointer no-underline"
        onMouseEnter={() => setHoveredText(true)}
        onMouseLeave={() => setHoveredText(false)}
        aria-label="Text us at 678-936-5391"
      >
        <span
          className={`
            bg-gray-900 text-white text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap
            transition-all duration-300 ease-in-out
            ${hoveredText ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4 pointer-events-none"}
          `}
        >
          Text Us: 678-936-5391
        </span>
        <div
          className="w-14 h-14 rounded-full bg-green-500 flex items-center justify-center hover:bg-green-600 active:scale-95 transition-all duration-200"
          style={{ boxShadow: "0 4px 20px rgba(34,197,94,0.45)" }}
        >
          <i className="ri-message-2-fill text-white text-2xl"></i>
        </div>
      </a>

    </div>
  );
}
